import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { veifiyBank } from "../../api";



/**
 * ReConfirmDetails component asks the user to confirm bank account details before submission.
 * Handles verification, loading state, and navigation based on API response.
 */
const ReConfirmDetails = ({ login = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useParams();
  const enteredValue = location.state?.enteredValue || {};
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const [isLoading, setIsLoading] = useState(false);

  const handleYesClick = async () => {
    setIsLoading(true);
    let formData = new FormData()
    formData.append('account_number', enteredValue.re_enter_account_number)
    formData.append('name_of_bank', enteredValue.name)
    formData.append('ifsc_code', enteredValue.ifsc_code)
    formData.append('re_enter_account_number', enteredValue.re_enter_account_number)
    formData.append('iirpl_sap_code', userId)
    veifiyBank(formData).then((data) => {
      if (data?.data?.accountStatus === 'VALID') {
        navigate(`/${redirectUrl}/addbank-details/${userId}`, {
          state: {
            bankdetails: data?.data?.data,
            enteredValue,
            userId,
          },
        });
      } else {
        navigate(`/${redirectUrl}/wrong-bank-details`, {
          state: { bankdetails: enteredValue, userId: userId },
        });
        // Handle error scenario as needed
      }
    }).catch(error => {
      // Handle API call error
      alert("API call error", error);
    }).finally(() => {
      //setIsLoading(false); // Set loading to false after API call
    });

  };

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-6 mt-3 pancard-data">
            <div className="text-center mb-7">
              <img
                width="50%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/reconfirmation-min.png")}
              />
            </div>
          </div>

          <div className="col-md-6 mt-3 pancard-data">
            <div className="mt-3">
              <h1 className="mb-5">Re-Confirm</h1>
              <p>Please make sure you have checked all your details.</p>
              <p>Name At Bank: {enteredValue.name}</p>
              <p>Account Number: {enteredValue.account_number}</p>
              <p>IFSC: {enteredValue.ifsc_code}</p>
              <div className="btns cn-btn mt-15 d-flex">
                <button
                  className="btn bgdark-blue text-white"
                  onClick={() => navigate(-1)}
                >
                  No
                </button>
                <button
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: isLoading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: isLoading ? "not-allowed" : "pointer",
                  }}
                  onClick={() => handleYesClick()}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReConfirmDetails;
